import React from 'react'
import NoDataMessage from 'components/NoDataMessage/NoDataMessage'
import ReportCalendarLoader from '../../ReportCalendarLoader'
import '../../styles/report-calendar-upcoming-reports.sass'

const isSameReportDay = (current, previous) => {
	if (!previous) {
		return false
	}

	return current.dateKey === previous.dateKey
}

const UpcomingReportCardTitle = ({ jurisdiction, reportType }) => (
	<p className='reporting-calendar-upcoming-reports__card-title'>
		<span className='reporting-calendar-upcoming-reports__card-jurisdiction'>{jurisdiction}</span>
		<span className='reporting-calendar-upcoming-reports__card-separator'> · </span>
		<span className='reporting-calendar-upcoming-reports__card-report-type'>{reportType}</span>
	</p>
)

const ReportCalendarUpcomingReports = ({
	groups = [],
	isLoading = false,
	onCreate,
	onReportSelect,
}) => {
	const hasReports = groups.some((group) => group.items?.length > 0)

	return (
		<section className='reporting-calendar-upcoming-reports'>
			<h2 className='reporting-calendar-upcoming-reports__title'>Upcoming reports</h2>

			{isLoading ? (
				<ReportCalendarLoader minHeight={220} />
			) : hasReports ? (
				<div className='reporting-calendar-upcoming-reports__list'>
					{groups.map((group) => (
						<div key={group.monthKey || group.monthLabel} className='reporting-calendar-upcoming-reports__month-group'>
							<div className='reporting-calendar-upcoming-reports__month-header'>
								<div className='reporting-calendar-upcoming-reports__date' aria-hidden='true' />
								<h3 className='reporting-calendar-upcoming-reports__month-label'>{group.monthLabel}</h3>
							</div>

							<div className='reporting-calendar-upcoming-reports__month-items'>
								{group.items.map((item, index) => {
									const previousItem = index > 0 ? group.items[index - 1] : null
									const showDate = !isSameReportDay(item, previousItem)

									return (
										<div key={item.id} className='reporting-calendar-upcoming-reports__row'>
											<div className='reporting-calendar-upcoming-reports__date'>
												{showDate && (
													<>
														<span className='reporting-calendar-upcoming-reports__weekday'>
															{item.weekday}
														</span>
														<span className='reporting-calendar-upcoming-reports__day'>
															{item.day}
														</span>
													</>
												)}
											</div>

											<button
												type='button'
												className={[
													'reporting-calendar-upcoming-reports__card',
													item.variant === 'urgent'
														? 'reporting-calendar-upcoming-reports__card--urgent'
														: item.variant === 'yellow'
															? 'reporting-calendar-upcoming-reports__card--yellow'
															: item.variant === 'success'
																? 'reporting-calendar-upcoming-reports__card--success'
																: 'reporting-calendar-upcoming-reports__card--default',
												].join(' ')}
												onClick={() => onReportSelect?.(item)}
											>
												<UpcomingReportCardTitle
													jurisdiction={item.jurisdiction}
													reportType={item.reportType}
												/>
												<p className='reporting-calendar-upcoming-reports__card-company'>
													{item.company}
												</p>
											</button>
										</div>
									)
								})}
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='reporting-calendar-upcoming-reports__empty'>
					<div className='reporting-calendar-upcoming-reports__empty-inner'>
						<NoDataMessage title='No reports yet' />
						<button
							type='button'
							className='reporting-calendar-upcoming-reports__create-btn'
							onClick={onCreate}
						>
							+ Create
						</button>
					</div>
				</div>
			)}
		</section>
	)
}

export default ReportCalendarUpcomingReports
